var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-danger rounded-0 btn-lg font-16",attrs:{"disabled":_vm.form.busy},on:{"click":function($event){return _vm.onBtnClick()}}},[(_vm.form.busy)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trans('strings.complete_payment')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }